import React, { Component } from 'react'
import { Input, Button } from '@driftt/tide'
import isUrl from 'is-url'

import { addhttps } from 'modules/settings/helpers'

import cx from 'classnames'

import './style.css'

const CUSTOM_LINK_DISPLAY_TEXT_MAX = 30

class CustomLinkForm extends Component {
  render() {
    const { onSave, onCancel, customLink, onDisplayTextChange, onUrlChange } = this.props
  
    const { url } = customLink.url ? addhttps(customLink.url) : ''
  
    return (
      <div className="custom-link-form-wrapper">
        <fieldset>
          <Input
            label='Link Title'
            value={customLink.displayText}
            onChange={onDisplayTextChange}
            className={cx('custom-link-display-text-input', {
              error: customLink.displayText.length > CUSTOM_LINK_DISPLAY_TEXT_MAX
            })}
          />
      
          <Input
            label="URL"
            value={customLink.url}
            onChange={onUrlChange}
            className={cx('custom-link-url-input', {
              error: url && !isUrl(url)
            })}
          />
        </fieldset>
    
        <div className="custom-link-form-action-buttons">
          {customLink.displayText.length > CUSTOM_LINK_DISPLAY_TEXT_MAX && <span className="display-text-error input-error-message">Please limit your custom link text to 30 characters</span>}
          {url && !isUrl(url) && <span className="url-error input-error-message">Please enter a valid url (e.g) http://www.drift.com</span> }
          <Button
            type="secondary"
            className="custom-link-form-save-button"
            onClick={onSave}
          >
            Save
          </Button>
      
          <Button
            type="tertiary"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }
}

export default CustomLinkForm